<template>
  <v-dialog
    v-if="selected"
    :value="dialog"
    :hide-overlay="!dialog"
    @click:outside.stop="closeDialog(true)"
    @keydown.esc="closeDialog(true)"
    persistent
    max-width="599px"
    :fullscreen="is_mobile"
    :scrollable="is_mobile"
    overlay-opacity="50"
    overlay-color="#ffffff"
    content-class="default-dialog"
    >
    <v-card class="default-dialog-card">
      <v-card-title>
        <span class="headline">
          <v-icon class="toolbar-icon" v-text="getTitle_.icon"/>
          {{ getTitle_.title }}
        </span>
        <v-spacer></v-spacer>
        <v-icon class="dialog-close-btn" @click="closeDialog(true)">mdi-close</v-icon>
      </v-card-title>
      <v-card-text class="px-1">
        <v-container
          v-bar="{ preventParentScroll: true, scrollThrottle: 30, resizeRefresh: true }"
          class="overflow-y-auto dialog-scrollbar"
          style="max-height: 350px; padding: 9px 0px !important;"
        >
          <div>
            <v-row v-if="fixed === 0" class="cash-form-row">
              <v-col cols="12">
                <v-card-text class="pt-0">
                  <span><strong>{{ lang.financial.cashflow.new.form.type }}</strong></span><br />
                  {{ getType(selected.type).title }}
                </v-card-text>
              </v-col>
            </v-row>
            <v-row class="cash-form-row">
              <v-col cols="12" lg="8" md="8" sm="12" class="py-0 px-1">
                <v-card-text class="pt-0">
                  <span><strong>{{ lang.financial.cashflow.new.form.title }}</strong></span><br />
                  {{ selected.title }}
                </v-card-text>
              </v-col>
              <v-col cols="12" lg="4" md="4" sm="12" class="py-0 px-1">
                <v-card-text class="pt-0">
                  <span><strong>{{ lang.financial.cashflow.new.form.value }}</strong></span><br />
                  {{ formatCurrency(selected.value) }}
                </v-card-text>
              </v-col>
            </v-row>
            <template v-if="selected.type < 2">
              <v-row class="pa-0" v-if="selected.order > 0">
                <v-col cols="12" class="pa-0 px-1 pb-3">
                  <Order
                    v-model="selected.order"
                    readOnly
                  />
                </v-col>
              </v-row>
              <v-row class="cash-form-row">
                <v-col cols="5">
                  <v-card-text class="pt-0">
                    <span><strong>{{ lang.financial.cashflow.new.form.method }}</strong></span><br />
                    {{ getMethod(selected.method).title }}
                  </v-card-text>
                </v-col>
                <v-col cols="3">
                  <v-card-text class="pt-0">
                    <span><strong>{{ lang.financial.cashflow.new.form.parcels }}</strong></span><br />
                    {{ `${selected.parcels}x` }}
                  </v-card-text>
                </v-col>
                <v-col cols="4">
                  <v-card-text class="pt-0">
                    <span><strong>{{ lang.financial.cashflow.new.form.taxes }}</strong></span><br />
                    {{ `${selected.taxes}% (${formatCurrency(parseFloat(parseFloat(selected.taxes) / 100) * selected.value)})` }}
                  </v-card-text>
                </v-col>
              </v-row>
            </template>
            <template v-else>
              <v-row v-if="fixed === 0" class="pa-0">
                <v-col cols="12" class="pa-0 px-1">
                  <v-card-text class="pt-0">
                    <span><strong>{{ lang.financial.cashflow.new.categories.title_s }}</strong></span><br />
                    {{ getCat(selected).title }}
                  </v-card-text>
                </v-col>
              </v-row>
              <v-row class="pa-0">
                <v-col cols="12" class="pa-3 px-1">
                  <Meta
                    v-model="selected.meta"
                    :category="selected.category"
                    :key="selected.category"
                    readOnly
                  />
                </v-col>
              </v-row>
            </template>
            <v-row class="cash-form-row">
              <v-col cols="12">
                <v-card-text class="pt-0">
                  <span><strong>{{ lang.financial.cashflow.new.form.notes }}</strong></span><br />
                  {{ selected.notes }}
                </v-card-text>
              </v-col>
            </v-row>
          </div>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="gray" text @click="closeDialog(true)">{{ lang.items.view.close }}</v-btn>
        <v-btn
          @click="$emit('edit', true)"
          :loading="get_interface.loading"
          :disabled="get_interface.loading"
          color="amber"
          text
        >
          {{ lang.financial.cashflow.actions.edit }}
        </v-btn>
        <v-btn
          @click="save_(selected)"
          :loading="get_interface.loading"
          :disabled="get_interface.loading"
          color="green darken-1"
          text
        >
          {{ lang.financial.cashflow.actions.save }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import Order from '@/components/orders/templates/UnpaidAutoComplete'
import Meta from './templates/Meta'

import appdata from '@/mixins/appdata'
import utils from '@/mixins/utils'
import view from '@/mixins/defaults/view'
import cashflow from './mixins/index'

export default {
  components: { Order, Meta },
  mixins: [ appdata, utils, view, cashflow ],
  props: {
    fixed: {
      type: Number,
      default: 0
    }
  },
  computed: {
    getTitle_ () {
      let page = (this.selected.type < 2 ? 'payment' : 'expense'),
          title_s = this.lang.financial.cashflow.new.types[page]
      return {
        icon: `mdi-cash-${(this.selected.type < 2 ? 'plus' : 'minus')}`,
        title: `${title_s} #${this.selected.id}`,
        title_s
      }
    }
  }
}
</script>

<style src="@/styles/inner/view.scss" lang="scss"></style>
